export const ASK_INPUT_DRAFTS_DB_NAME = 'pplx-ask-input-drafts';
export function areAskInputDraftContextsEqual(left, right) {
    return left.threadUuid === right.threadUuid;
}
//# sourceMappingURL=types.js.map